import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projects: [
    {
      id: '1',
      title: "SOC Home Lab (Threat Detection Practice)",
      description: "Built a personal SOC lab using Graylog SIEM, OSSEC EDR, Suricata IDS, and pfSense firewall, simulating attacks and practicing real-time event detection and response.",
      tools: ["Graylog SIEM", "OSSEC EDR", "Suricata IDS", "pfSense Firewall", "Linux", "VirtualBox"],
      icon: "Shield",
      github: "https://github.com/Magoban/Detection-Lab"
    },
    {
      id: '2',
      title: "AI-Powered Log Analyzer (SOC Automation)",
      description: "Integrated Hugging Face AI into SOC lab for automated security log analysis using NLP models to identify threats and reduce manual analysis time.",
      tools: ["Hugging Face", "NLP Models", "Python", "Machine Learning", "Log Analysis", "Automation"],
      icon: "Brain",
      github: "https://github.com/Magoban/AI-Security-Log-Analyzer"
    },
    {
      id: '3',
      title: "SOAR-Driven EDR Workflow (LimaCharlie + Tines)",
      description: "Developed an automated incident response workflow using LimaCharlie, Tines, Slack, and Email, including detection rules and playbooks for machine isolation and real-time analyst interaction.",
      tools: ["LimaCharlie", "Tines", "Slack", "Email Integration", "SOAR", "Incident Response"],
      icon: "Workflow"
    },
    {
      id: '4',
      title: "Malware Analysis & Reverse Engineering",
      description: "Used FlareVM, Remnux, and Volatility to analyze malware samples, extract IOCs, and understand malware behavior through static and dynamic analysis techniques.",
      tools: ["FlareVM", "Remnux", "Volatility", "Autopsy", "YARA Rules", "Malware Analysis"],
      icon: "Bug",
      github: "https://github.com/Magoban/Malware-Analysis-Lab"
    },
    {
      id: '5',
      title: "Stock Price Prediction (Python + ARIMA)",
      description: "Predicted stock prices for Google and Microsoft using yfinance, Linear Regression, and ARIMA models, showcasing analytical and forecasting skills applicable to threat prediction.",
      tools: ["Python", "yfinance", "Linear Regression", "ARIMA", "Data Analysis", "Forecasting"],
      icon: "TrendingUp",
      github: "https://github.com/Magoban/Stock-Prediction-Project"
    },
    {
      id: '6',
      title: "Python-Based Keylogger (Ethical Malware Project)",
      description: "Developed a keylogger with stealth functionality, real-time keystroke logging, periodic screenshots, clipboard capture, and optional data exfiltration via email for educational purposes.",
      tools: ["Python", "Windows API", "Stealth Techniques", "Email Integration", "Ethical Hacking", "Security Research"],
      icon: "Code",
      github: "https://github.com/Magoban/Python-based-Keylogger"
    }
  ]
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    addProject: (state, action) => {
      const newProject = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.projects.push(newProject);
    },
    updateProject: (state, action) => {
      const { id, ...updates } = action.payload;
      const projectIndex = state.projects.findIndex(project => project.id === id);
      if (projectIndex !== -1) {
        state.projects[projectIndex] = { ...state.projects[projectIndex], ...updates };
      }
    },
    deleteProject: (state, action) => {
      state.projects = state.projects.filter(project => project.id !== action.payload);
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    rehydrateProjects: (state, action) => {
      if (action.payload && action.payload.projects) {
        state.projects = action.payload.projects;
      }
    }
  }
});

export const { addProject, updateProject, deleteProject, setProjects, rehydrateProjects } = projectsSlice.actions;
export default projectsSlice.reducer; 